import React, { FC, Fragment } from 'react';
import { Grid } from '@material-ui/core';

import { LoaderComponents } from 'components';

interface IProps {
  rows: number;
}

const Loader: FC<IProps> = ({ rows }) => {
  const { Block, Content, Divider, List, Row } = LoaderComponents;

  return (
    <List rows={rows}>
      {rowIndex => (
        <Fragment key={rowIndex}>
          <Divider />
          <Row padding="13px 9px" spacing={4}>
            <Grid item>
              <Block height={25} width={25} />
            </Grid>
            <Grid item>
              <Content index={rowIndex} height={25} maxWidth={400} />
            </Grid>
          </Row>
          <Divider />
        </Fragment>
      )}
    </List>
  );
};

export default Loader;
